import React, { useState } from 'react'
import { Modal, Input, Button, message } from 'antd'
import { ContentDataType } from '../../../SelectMaterial'
import * as API from '../../../../../api'

export interface WebCrawlerModalProps {
	visible: boolean;
	handleVisible: (val: boolean) => void;
	onSuccess?: (val: ContentDataType[]) => void;
}

const WebCrawlerModal: React.FC<WebCrawlerModalProps> = ({
	visible,
	handleVisible,
	onSuccess,
}) => {
	const [webUrl, setWebUrl] = useState<string>('')
	const [loading, setLoading] = useState<boolean>(false)

	const handleModalVisible = (val: boolean) => {
		handleVisible(val)
		setLoading(false)
	}

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setWebUrl(e.target.value)
	}

	/**
	 * 从网页中抓取内容
	 */
	const grabFromWeb = async (val: string) => {
		const reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
		if (!val) {
			message.warning('网址链接不能为空')
			return
		}
		if (!reg.test(val)) {
			message.error('请输入正确的网络链接')
			return
		}

		// 请求接口
		setLoading(true)
		try {
			const { code, data, msg } = await API.grabFromWeb({ url: webUrl })
			setLoading(false)
			if (code === '200') {
				if (!data) {
					message.warning('暂无内容')
					return
				}
				const { textData, picData } = data
				const submitList: ContentDataType[] = []
				textData && textData.map(item => submitList.push({ st_text_content: item.text, type: '文章' }))
				picData && picData.map(item => submitList.push({ st_fileurl: item.picSrc, type: '图片' }))
				handleModalVisible(false)
				onSuccess && onSuccess(submitList)
			} else {
				message.error(msg)
			}
		} catch (error) {
			message.error('提取失败')
			setLoading(false)
		}
	}

	const handleConfirm = () => {
		handleModalVisible(false)
	}

	const handleCancel = () => {
		handleModalVisible(false)
	}

	return (
		<Modal
			title="从网页中提取"
			visible={visible}
			onOk={handleConfirm}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>取消</Button>,
			]}
			centered
		>
			<Input.Search
				placeholder="请输入网址链接"
				enterButton="从网页中提取"
				value={webUrl}
				loading={loading}
				onChange={handleInputChange}
				onSearch={grabFromWeb}
			/>
		</Modal>
	)
}

export default WebCrawlerModal